import React from 'react';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  name: 'Mariana Torres',
  role: 'Docente de Primaria',
  text: 'Lo que más me gustó es que no tuve que preparar nada. Abrí el PDF, imprimí las actividades y pude trabajar ESI desde el primer día.'
}, {
  name: 'Paula Fernández',
  role: 'Maestra de Grado',
  text: 'Las actividades son claras, visuales y fáciles de aplicar. Me ayudaron muchísimo para trabajar emociones y convivencia con mis estudiantes.'
}, {
  name: 'Carolina López',
  role: 'Docente de Primaria',
  text: 'Ciudadanía digital era un tema que me costaba abordar. Con este material tuve actividades listas para usar y los chicos participaron muchísimo.'
}];
export function TestimonialsSection() {
  return <section className="py-6 px-4 bg-gray-50" data-id="element-181">
      <div className="max-w-6xl mx-auto" data-id="element-182">
        <h2 className="text-[20px] font-black mb-5 text-center text-[#EF5B4C]" data-id="element-183">
          Lo que dicen quienes ya utilizan los materiales de Aula Mater
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-184">
          {testimonials.map((t, index) => <div key={index} className="bg-white p-4 rounded-2xl shadow-md border border-gray-100 flex flex-col" data-id="element-185">
              <div className="flex mb-2" data-id="element-186">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-187" />)}
              </div>
              <p className="text-gray-700 italic mb-3 flex-grow" data-id="element-188">"{t.text}"</p>
              <div className="border-t pt-3 mt-auto" data-id="element-189">
                <p className="font-bold text-gray-900" data-id="element-190">{t.name}</p>
                <p className="text-sm text-gray-500" data-id="element-191">{t.role}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}